// Public + private i18n (booking page, appointment token, landing, marketplace, key admin labels)
// Locales: es (default), ca, en, pt

const DICTS = {
  es: {
    "reserva.online": "Reserva online",
    "paso.operario": "Operario",
    "paso.centro": "Centro",
    "desde": "Desde",
    "paso.servicio": "Servicio",
    "paso.complementos": "Complementos",
    "paso.fecha": "Fecha y hora",
    "paso.datos": "Tus datos",
    "elige.servicio": "Elige tu servicio",
    "que.necesita": "¿Qué necesita tu coche?",
    "elige.fecha": "Elige fecha y hora",
    "slots.libres": "Slots libres",
    "sin.slots": "Sin slots disponibles",
    "cambiar.servicio": "← Cambiar servicio",
    "cambiar.hora": "← Cambiar hora",
    "atras": "Atrás",
    "volver": "Volver",
    "siguiente": "Siguiente",
    "complementos.titulo": "Añade complementos",
    "complementos.subtitulo": "Personaliza tu servicio. Puedes saltar este paso si no necesitas extras.",
    "complementos.cantidad": "Cantidad",
    "complementos.sin": "Este servicio no tiene complementos disponibles. Puedes continuar.",
    "complementos.saltar": "Saltar este paso",
    "complementos.continuar": "Continuar",
    "total": "Total",
    "incluye": "Incluye",
    "datos": "Tus datos",
    "matricula": "Matrícula",
    "marca.modelo": "Marca / Modelo",
    "tu.nombre": "Tu nombre",
    "email": "Email",
    "telefono": "Teléfono",
    "notas": "Notas (opcional)",
    "notas.placeholder": "Cualquier indicación que debamos saber",
    "opcional": "(opcional)",
    "indica.uno": "Indica al menos uno: email para confirmación detallada o teléfono para que el taller pueda contactarte.",
    "wa.aviso": "Te avisaremos por chat interno y push notifications cuando confirmemos la cita y cuando tu coche esté listo para recogida.",
    "confirmar.reserva": "Confirmar reserva",
    "reservando": "Reservando…",
    "reserva.confirmada": "Reserva confirmada",
    "te.esperamos": "¡Te esperamos!",
    "servicio": "Servicio",
    "fecha": "Fecha",
    "duracion": "Duración estimada",
    "email.enviado": "Te hemos enviado un email con todos los detalles.",
    "rango": "rango",
    "min": "min",
    "vat.label": "IVA",
    "rgpd": "Al continuar aceptas el tratamiento de tus datos por {org} ({nif}) con la única finalidad de gestionar esta reserva, conforme al RGPD (UE 2016/679) y LOPDGDD 3/2018.",
    "captcha.mock": "Protección anti-spam activa (Turnstile MOCKED en demo)",
    "reservar.otra": "Reservar otra cita",
    "tu.reserva": "Tu reserva",
    "vas.venir": "¿Vas a venir? Confírmalo, o cancela para que liberemos tu hueco.",
    "confirmar": "Confirmar",
    "cancelar": "Cancelar",
    "cancelando": "Cancelando…",
    "cita.cancelada": "Cita cancelada",
    "cita.confirmada": "¡Cita confirmada!",
    "slot.liberado": "El slot ha sido liberado. Gracias por avisarnos a tiempo.",
    "gracias.confirmar": "Gracias por confirmar. Te esperamos puntual.",
    "cancelar.de.todos.modos": "Cancelar de todos modos",
    "enlace.invalido": "Enlace inválido",
    "404.msg": "Esta cita no existe o el enlace ha caducado.",
    "cualquier.profesional": "Cualquier profesional",
    "elige.quien": "¿Quién te atenderá?",
    "segun.disponibilidad": "Según disponibilidad",
    // --- panel privado (Bloque 4) ---
    "nav.dashboard": "Resumen",
    "nav.servicios": "Servicios",
    "nav.agenda": "Agenda",
    "nav.mensajes": "Mensajes",
    "nav.equipo": "Equipo",
    "nav.clientes": "Clientes",
    "nav.catalogo": "Catálogo",
    "nav.gastos": "Gastos",
    "nav.liquidaciones": "Liquidaciones",
    "nav.bonos": "Bonos",
    "nav.aeat": "Modelos AEAT",
    "nav.ajustes": "Ajustes",
    "nav.facturacion": "Plan & Pago",
    "nav.proveedores": "Proveedores",
    "nav.leads": "Bandeja de leads",
    "nav.analiticas": "Analíticas",
    "nav.avisos": "Avisos del equipo",
    "nav.contratos": "Contratos recurrentes",
    "nav.midisponibilidad": "Mi disponibilidad",
    "nav.mifactura": "Mi factura mensual",
    "nav.salir": "Salir",
    "dash.bienvenida": "Bienvenido",
    "dash.servicios_mes": "Servicios este mes",
    "dash.facturacion_mes": "Facturación del mes",
    "dash.colaboradores": "Colaboradores activos",
    "dash.actividad": "Actividad reciente",
    "common.guardar": "Guardar",
    "common.cancelar": "Cancelar",
    "common.eliminar": "Eliminar",
    "common.editar": "Editar",
    "common.nuevo": "Nuevo",
    "common.buscar": "Buscar",
    "common.cargando": "Cargando…",
    "common.sin_resultados": "Sin resultados",
    "common.cerrar": "Cerrar",
    "tema.claro": "Modo claro",
    "tema.oscuro": "Modo oscuro",
    // --- landing / marketplace hero (Sprint A) ---
    "hero.tagline.eyebrow": "AutoGlow Ecosystem",
    "hero.tagline": "AutoGlow lleva tus reservas online.",
    "hero.subtitle": "El software que usan los mejores talleres, detailers y chapistas para reservar, facturar y crecer.",
    "hero.cta.start": "Probar AutoGlow gratis",
    "hero.cta.demo": "Ver marketplace",
    "hero.trial": "30 días de prueba · sin tarjeta",
    "marketplace.title": "Marketplace profesional del motor",
    "marketplace.subtitle": "Encuentra detailers, mecánicos, talleres de chapa y pintura. Reserva con precio cerrado.",
    "marketplace.search_placeholder": "Buscar por ciudad, localidad o nombre…",
    "marketplace.no_results": "Sin centros disponibles ahora mismo.",
    "cta.client.title": "Soy cliente\nbusco un profesional",
    "cta.client.sub": "Encuentra detailer, mecánico o taller cerca y reserva en segundos.",
    "cta.pro.title": "Soy profesional\nquiero digitalizar mi negocio",
    "cta.pro.sub": "Software completo para freelancers, microempresas y talleres profesionales del motor.",
  },
  ca: {
    "reserva.online": "Reserva online",
    "paso.operario": "Operari",
    "paso.centro": "Centre",
    "desde": "Des de",
    "paso.servicio": "Servei",
    "paso.complementos": "Complements",
    "paso.fecha": "Data i hora",
    "paso.datos": "Les teves dades",
    "elige.servicio": "Tria el teu servei",
    "que.necesita": "Què necessita el teu cotxe?",
    "elige.fecha": "Tria data i hora",
    "slots.libres": "Slots disponibles",
    "sin.slots": "Sense disponibilitat",
    "cambiar.servicio": "← Canviar servei",
    "cambiar.hora": "← Canviar hora",
    "atras": "Enrere",
    "volver": "Tornar",
    "siguiente": "Següent",
    "complementos.titulo": "Afegeix complements",
    "complementos.subtitulo": "Personalitza el servei. Pots saltar aquest pas si no vols extres.",
    "complementos.cantidad": "Quantitat",
    "complementos.sin": "Aquest servei no té complements disponibles. Pots continuar.",
    "complementos.saltar": "Saltar aquest pas",
    "complementos.continuar": "Continuar",
    "total": "Total",
    "incluye": "Inclou",
    "datos": "Les teves dades",
    "matricula": "Matrícula",
    "marca.modelo": "Marca / Model",
    "tu.nombre": "El teu nom",
    "email": "Email",
    "telefono": "Telèfon",
    "notas": "Notes (opcional)",
    "notas.placeholder": "Qualsevol indicació que haguem de saber",
    "opcional": "(opcional)",
    "indica.uno": "Indica almenys un: email per a confirmació detallada o telèfon perquè el taller pugui contactar-te.",
    "wa.aviso": "T'avisarem per xat intern i notificacions push quan confirmem la cita i quan el teu cotxe estigui llest per recollir.",
    "confirmar.reserva": "Confirmar reserva",
    "reservando": "Reservant…",
    "reserva.confirmada": "Reserva confirmada",
    "te.esperamos": "T'esperem!",
    "servicio": "Servei",
    "fecha": "Data",
    "duracion": "Durada estimada",
    "email.enviado": "T'hem enviat un email amb tots els detalls.",
    "rango": "rang",
    "min": "min",
    "vat.label": "IVA",
    "rgpd": "En continuar acceptes el tractament de les teves dades per {org} ({nif}) amb l'única finalitat de gestionar aquesta reserva, conforme al RGPD (UE 2016/679) i LOPDGDD 3/2018.",
    "captcha.mock": "Protecció anti-spam activa (Turnstile MOCKED a la demo)",
    "reservar.otra": "Reservar una altra cita",
    "tu.reserva": "La teva reserva",
    "vas.venir": "Vens? Confirma-ho o cancel·la perquè alliberem el teu lloc.",
    "confirmar": "Confirmar",
    "cancelar": "Cancel·lar",
    "cancelando": "Cancel·lant…",
    "cita.cancelada": "Cita cancel·lada",
    "cita.confirmada": "Cita confirmada!",
    "slot.liberado": "El slot s'ha alliberat. Gràcies per avisar a temps.",
    "gracias.confirmar": "Gràcies per confirmar. T'esperem puntual.",
    "cancelar.de.todos.modos": "Cancel·lar de totes maneres",
    "enlace.invalido": "Enllaç invàlid",
    "404.msg": "Aquesta cita no existeix o l'enllaç ha caducat.",
    "cualquier.profesional": "Qualsevol professional",
    "elige.quien": "Qui t'atendrà?",
    "segun.disponibilidad": "Segons disponibilitat",
    "nav.dashboard": "Resum",
    "nav.servicios": "Serveis",
    "nav.agenda": "Agenda",
    "nav.mensajes": "Missatges",
    "nav.equipo": "Equip",
    "nav.clientes": "Clients",
    "nav.catalogo": "Catàleg",
    "nav.gastos": "Despeses",
    "nav.liquidaciones": "Liquidacions",
    "nav.bonos": "Bons",
    "nav.aeat": "Models AEAT",
    "nav.ajustes": "Ajustaments",
    "nav.facturacion": "Pla & Pagament",
    "nav.proveedores": "Proveïdors",
    "nav.leads": "Safata de leads",
    "nav.analiticas": "Analítica",
    "nav.avisos": "Avisos de l'equip",
    "nav.contratos": "Contractes recurrents",
    "nav.midisponibilidad": "La meva disponibilitat",
    "nav.mifactura": "La meva factura mensual",
    "nav.salir": "Sortir",
    "dash.bienvenida": "Benvingut",
    "dash.servicios_mes": "Serveis aquest mes",
    "dash.facturacion_mes": "Facturació del mes",
    "dash.colaboradores": "Col·laboradors actius",
    "dash.actividad": "Activitat recent",
    "common.guardar": "Desa",
    "common.cancelar": "Cancel·la",
    "common.eliminar": "Elimina",
    "common.editar": "Edita",
    "common.nuevo": "Nou",
    "common.buscar": "Cerca",
    "common.cargando": "Carregant…",
    "common.sin_resultados": "Sense resultats",
    "common.cerrar": "Tanca",
    "tema.claro": "Mode clar",
    "tema.oscuro": "Mode fosc",
    "hero.tagline.eyebrow": "AutoGlow Ecosystem",
    "hero.tagline": "AutoGlow porta les teves reserves en línia.",
    "hero.subtitle": "El programari que utilitzen els millors tallers, detailers i planxistes per reservar, facturar i créixer.",
    "hero.cta.start": "Provar AutoGlow gratis",
    "hero.cta.demo": "Veure marketplace",
    "hero.trial": "30 dies de prova · sense targeta",
    "marketplace.title": "Marketplace professional del motor",
    "marketplace.subtitle": "Troba detailers, mecànics, tallers de xapa i pintura. Reserva amb preu tancat.",
    "marketplace.search_placeholder": "Cerca per ciutat, localitat o nom…",
    "marketplace.no_results": "Sense centres disponibles ara mateix.",
    "cta.client.title": "Sóc client\nbusco un professional",
    "cta.client.sub": "Troba detailer, mecànic o taller a prop i reserva en segons.",
    "cta.pro.title": "Sóc professional\nvull digitalitzar el meu negoci",
    "cta.pro.sub": "Programari complet per a autònoms, microempreses i tallers professionals.",
  },
  en: {
    "reserva.online": "Online booking",
    "paso.operario": "Operator",
    "paso.centro": "Center",
    "desde": "From",
    "paso.servicio": "Service",
    "paso.complementos": "Add-ons",
    "paso.fecha": "Date & time",
    "paso.datos": "Your details",
    "elige.servicio": "Choose your service",
    "que.necesita": "What does your car need?",
    "elige.fecha": "Pick date and time",
    "slots.libres": "Available slots",
    "sin.slots": "No slots available",
    "cambiar.servicio": "← Change service",
    "cambiar.hora": "← Change time",
    "atras": "Back",
    "volver": "Back",
    "siguiente": "Next",
    "complementos.titulo": "Add extras",
    "complementos.subtitulo": "Tailor your service. You can skip this step if you don't need any extras.",
    "complementos.cantidad": "Quantity",
    "complementos.sin": "This service has no add-ons. You can continue.",
    "complementos.saltar": "Skip this step",
    "complementos.continuar": "Continue",
    "total": "Total",
    "incluye": "Includes",
    "datos": "Your details",
    "matricula": "License plate",
    "marca.modelo": "Make / Model",
    "tu.nombre": "Your name",
    "email": "Email",
    "telefono": "Phone",
    "notas": "Notes (optional)",
    "notas.placeholder": "Anything we should know",
    "opcional": "(optional)",
    "indica.uno": "Provide at least one: email for detailed confirmation or phone so the shop can reach you.",
    "wa.aviso": "We'll notify you via internal chat and push notifications when we confirm the booking and when your car is ready.",
    "confirmar.reserva": "Confirm booking",
    "reservando": "Booking…",
    "reserva.confirmada": "Booking confirmed",
    "te.esperamos": "See you soon!",
    "servicio": "Service",
    "fecha": "Date",
    "duracion": "Estimated duration",
    "email.enviado": "We've emailed you the full details.",
    "rango": "range",
    "min": "min",
    "vat.label": "VAT",
    "rgpd": "By continuing you accept the processing of your data by {org} ({nif}) for the sole purpose of managing this booking, in compliance with GDPR (EU 2016/679).",
    "captcha.mock": "Anti-spam protection active (Turnstile MOCKED in demo)",
    "reservar.otra": "Book another appointment",
    "tu.reserva": "Your booking",
    "vas.venir": "Coming? Confirm it, or cancel so we can free the slot.",
    "confirmar": "Confirm",
    "cancelar": "Cancel",
    "cancelando": "Cancelling…",
    "cita.cancelada": "Appointment cancelled",
    "cita.confirmada": "Appointment confirmed!",
    "slot.liberado": "The slot has been freed. Thanks for letting us know in time.",
    "gracias.confirmar": "Thanks for confirming. See you on time.",
    "cancelar.de.todos.modos": "Cancel anyway",
    "enlace.invalido": "Invalid link",
    "404.msg": "This appointment does not exist or the link has expired.",
    "cualquier.profesional": "Any professional",
    "elige.quien": "Who will assist you?",
    "segun.disponibilidad": "Based on availability",
    "nav.dashboard": "Dashboard",
    "nav.servicios": "Services",
    "nav.agenda": "Calendar",
    "nav.mensajes": "Messages",
    "nav.equipo": "Team",
    "nav.clientes": "Customers",
    "nav.catalogo": "Catalogue",
    "nav.gastos": "Expenses",
    "nav.liquidaciones": "Payroll",
    "nav.bonos": "Vouchers",
    "nav.aeat": "Tax forms",
    "nav.ajustes": "Settings",
    "nav.facturacion": "Plan & Billing",
    "nav.proveedores": "Suppliers",
    "nav.leads": "Leads inbox",
    "nav.analiticas": "Analytics",
    "nav.avisos": "Team notices",
    "nav.contratos": "Recurring contracts",
    "nav.midisponibilidad": "My availability",
    "nav.mifactura": "My monthly invoice",
    "nav.salir": "Sign out",
    "dash.bienvenida": "Welcome",
    "dash.servicios_mes": "Services this month",
    "dash.facturacion_mes": "Revenue this month",
    "dash.colaboradores": "Active team",
    "dash.actividad": "Recent activity",
    "common.guardar": "Save",
    "common.cancelar": "Cancel",
    "common.eliminar": "Delete",
    "common.editar": "Edit",
    "common.nuevo": "New",
    "common.buscar": "Search",
    "common.cargando": "Loading…",
    "common.sin_resultados": "No results",
    "common.cerrar": "Close",
    "tema.claro": "Light mode",
    "tema.oscuro": "Dark mode",
    "hero.tagline.eyebrow": "AutoGlow Ecosystem",
    "hero.tagline": "AutoGlow takes your bookings online.",
    "hero.subtitle": "The software top detailers, mechanics and bodyshops use to book, invoice and grow.",
    "hero.cta.start": "Try AutoGlow free",
    "hero.cta.demo": "Open marketplace",
    "hero.trial": "30-day free trial · no card needed",
    "marketplace.title": "Motor professional marketplace",
    "marketplace.subtitle": "Find detailers, mechanics, bodyshops and paint specialists. Book with a fixed price.",
    "marketplace.search_placeholder": "Search by city, area or name…",
    "marketplace.no_results": "No centres available at this moment.",
    "cta.client.title": "I'm a customer\nlooking for a pro",
    "cta.client.sub": "Find a detailer, mechanic or bodyshop nearby and book in seconds.",
    "cta.pro.title": "I'm a professional\nwant to digitalise my business",
    "cta.pro.sub": "Complete software for freelancers, micro-businesses and motor industry shops.",
  },
  pt: {
    "reserva.online": "Reserva online",
    "paso.operario": "Profissional",
    "paso.centro": "Centro",
    "desde": "Desde",
    "paso.servicio": "Serviço",
    "paso.complementos": "Complementos",
    "paso.fecha": "Data e hora",
    "paso.datos": "Seus dados",
    "elige.servicio": "Escolha o seu serviço",
    "que.necesita": "Do que o seu carro precisa?",
    "elige.fecha": "Escolha data e hora",
    "slots.libres": "Horários disponíveis",
    "sin.slots": "Sem horários disponíveis",
    "cambiar.servicio": "← Alterar serviço",
    "cambiar.hora": "← Alterar hora",
    "atras": "Voltar",
    "volver": "Voltar",
    "siguiente": "Seguinte",
    "complementos.titulo": "Adicione extras",
    "complementos.subtitulo": "Personalize o seu serviço. Pode saltar este passo se não precisar de extras.",
    "complementos.cantidad": "Quantidade",
    "complementos.sin": "Este serviço não tem complementos disponíveis. Pode continuar.",
    "complementos.saltar": "Saltar este passo",
    "complementos.continuar": "Continuar",
    "total": "Total",
    "incluye": "Inclui",
    "datos": "Seus dados",
    "matricula": "Matrícula",
    "marca.modelo": "Marca / Modelo",
    "tu.nombre": "O seu nome",
    "email": "Email",
    "telefono": "Telefone",
    "notas": "Notas (opcional)",
    "notas.placeholder": "Qualquer indicação que devamos saber",
    "opcional": "(opcional)",
    "indica.uno": "Indique pelo menos um: email para confirmação detalhada ou telefone para que a oficina possa contactá-lo.",
    "wa.aviso": "Notificaremos via chat interno e push quando confirmarmos a reserva e quando o seu carro estiver pronto.",
    "confirmar.reserva": "Confirmar reserva",
    "reservando": "A reservar…",
    "reserva.confirmada": "Reserva confirmada",
    "te.esperamos": "Esperamos por si!",
    "servicio": "Serviço",
    "fecha": "Data",
    "duracion": "Duração estimada",
    "email.enviado": "Enviámos-lhe um email com todos os detalhes.",
    "rango": "intervalo",
    "min": "min",
    "vat.label": "Impostos",
    "rgpd": "Ao continuar aceita o tratamento dos seus dados por {org} ({nif}) com o único objetivo de gerir esta reserva, em conformidade com o RGPD (UE 2016/679).",
    "captcha.mock": "Proteção anti-spam ativa (Turnstile MOCKED na demo)",
    "reservar.otra": "Reservar outra marcação",
    "tu.reserva": "A sua reserva",
    "vas.venir": "Vai vir? Confirme, ou cancele para libertarmos o horário.",
    "confirmar": "Confirmar",
    "cancelar": "Cancelar",
    "cancelando": "A cancelar…",
    "cita.cancelada": "Marcação cancelada",
    "cita.confirmada": "Marcação confirmada!",
    "slot.liberado": "O horário foi libertado. Obrigado por avisar a tempo.",
    "gracias.confirmar": "Obrigado por confirmar. Esperamos por si.",
    "cancelar.de.todos.modos": "Cancelar mesmo assim",
    "enlace.invalido": "Ligação inválida",
    "404.msg": "Esta marcação não existe ou a ligação expirou.",
    "cualquier.profesional": "Qualquer profissional",
    "elige.quien": "Quem irá atendê-lo?",
    "segun.disponibilidad": "Conforme disponibilidade",
    "nav.dashboard": "Resumo",
    "nav.servicios": "Serviços",
    "nav.agenda": "Agenda",
    "nav.mensajes": "Mensagens",
    "nav.equipo": "Equipa",
    "nav.clientes": "Clientes",
    "nav.catalogo": "Catálogo",
    "nav.gastos": "Despesas",
    "nav.liquidaciones": "Liquidações",
    "nav.bonos": "Pacotes",
    "nav.aeat": "Impostos",
    "nav.ajustes": "Definições",
    "nav.facturacion": "Plano & Pagamento",
    "nav.proveedores": "Fornecedores",
    "nav.leads": "Caixa de leads",
    "nav.analiticas": "Analítica",
    "nav.avisos": "Avisos da equipa",
    "nav.contratos": "Contratos recorrentes",
    "nav.midisponibilidad": "A minha disponibilidade",
    "nav.mifactura": "A minha fatura mensal",
    "nav.salir": "Sair",
    "dash.bienvenida": "Bem-vindo",
    "dash.servicios_mes": "Serviços este mês",
    "dash.facturacion_mes": "Faturação do mês",
    "dash.colaboradores": "Equipa ativa",
    "dash.actividad": "Atividade recente",
    "common.guardar": "Guardar",
    "common.cancelar": "Cancelar",
    "common.eliminar": "Eliminar",
    "common.editar": "Editar",
    "common.nuevo": "Novo",
    "common.buscar": "Pesquisar",
    "common.cargando": "A carregar…",
    "common.sin_resultados": "Sem resultados",
    "common.cerrar": "Fechar",
    "tema.claro": "Modo claro",
    "tema.oscuro": "Modo escuro",
    "hero.tagline.eyebrow": "AutoGlow Ecosystem",
    "hero.tagline": "A AutoGlow leva as tuas reservas online.",
    "hero.subtitle": "O software que os melhores detailers, oficinas e bate-chapas usam para reservar, faturar e crescer.",
    "hero.cta.start": "Começar grátis",
    "hero.cta.demo": "Ver marketplace",
    "hero.trial": "30 dias de teste · sem cartão",
    "marketplace.title": "Marketplace profissional do motor",
    "marketplace.subtitle": "Encontre detailers, mecânicos, oficinas e pintores. Reserve com preço fechado.",
    "marketplace.search_placeholder": "Procurar por cidade, localidade ou nome…",
    "marketplace.no_results": "Sem centros disponíveis no momento.",
    "cta.client.title": "Sou cliente\nprocuro um profissional",
    "cta.client.sub": "Encontre detailer, mecânico ou oficina perto e reserve em segundos.",
    "cta.pro.title": "Sou profissional\nquero digitalizar o meu negócio",
    "cta.pro.sub": "Software completo para freelancers, microempresas e oficinas profissionais.",
  },
};

export const LOCALES = [
  { code: "es", label: "ES", flag: "🇪🇸" },
  // Sprint P.1.5 · Bloque N (CP4): CA y PT ocultos en el switcher público hasta
  // que tengan 100% de traducción validada. Sus DICTS existen (fallback seguro
  // a ES si alguna cadena falta) pero no queremos exponerlos al usuario y romper
  // la percepción de calidad. Cuando estén completos, quitar el flag beta.
  { code: "ca", label: "CA", flag: "🏴", beta: true },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "pt", label: "PT", flag: "🇵🇹", beta: true },
];

/**
 * Locales visibles en la UI pública (switcher). Los locales `beta` se cargan
 * si el usuario los tiene guardados en localStorage, pero no se ofrecen para
 * seleccionar hasta que se marquen como stable.
 */
export const PUBLIC_LOCALES = LOCALES.filter((l) => !l.beta);

export function getLocale() {
  if (typeof window === "undefined") return "es";
  const stored = window.localStorage.getItem("ww_locale");
  if (stored && DICTS[stored]) return stored;
  // Sprint P.1.5 · Bloque C (CP4) · Fix P0-K.
  //   Anteriormente hacíamos fallback a `navigator.language`, lo que provocaba
  //   que /marketplace y /centro/:slug cargaran en inglés por defecto cuando el
  //   navegador declaraba `en-*` (headless, preview, usuarios con Chrome en EN).
  //   El mercado objetivo es España → default forzado a "es" salvo elección
  //   explícita persistida en localStorage. La preferencia guardada del usuario
  //   NUNCA se sobrescribe (rama `stored` arriba tiene prioridad).
  return "es";
}

export function setLocale(code) {
  if (DICTS[code]) window.localStorage.setItem("ww_locale", code);
}

export function t(key, locale, params = {}) {
  const dict = DICTS[locale] || DICTS.es;
  let s = dict[key] || DICTS.es[key] || key;
  Object.entries(params).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
  return s;
}

/**
 * Choose the best available translation for a service/addon catalog item.
 * Item shape: { name, translations: {es,ca,en,pt} } — falls back to `name` (Spanish).
 */
export function pickName(item, locale) {
  if (!item) return "";
  const tr = item.translations || {};
  return tr[locale] || tr.es || item.name || "";
}
